import { DEFINITION_BY_ID, type PuaStyleDefinition } from "./definitions"
import { MARKER_CLOSE, MARKER_OPEN } from "./markers"
import { stripAllPua } from "./strip"
import { validateMarkers } from "./validate"

export interface StyledRun {
  readonly text: string
  /** そのランに効く装飾クラス。外側の装飾から順。空配列＝無装飾 */
  readonly classNames: readonly string[]
}

/**
 * 1行のテキストをスタイル付きランの列へ分解する無状態の純関数。
 *
 * 保証: 戻り値の text にPUAが1文字も残らない（スクリーンリーダーのPUA読み上げは
 * 未定義動作のため、最終DOMにPUAを残さないことが必須要件）。
 * 不整合な入力は throw せず、PUAを全除去した無装飾ランへフォールバックする。
 * ネストは「現在開いている装飾の集合」を classNames に展開して表現する。
 */
export function tokenize(line: string): StyledRun[] {
  if (!validateMarkers(line)) {
    const stripped = stripAllPua(line)
    return stripped === "" ? [] : [{ text: stripped, classNames: [] }]
  }
  const runs: StyledRun[] = []
  const stack: PuaStyleDefinition[] = []
  let buffer = ""
  const flush = (): void => {
    if (buffer !== "") {
      runs.push({ text: buffer, classNames: stack.map((def) => def.className) })
      buffer = ""
    }
  }
  const chars = [...line]
  for (let i = 0; i < chars.length; i++) {
    const ch = chars[i]
    if (ch === undefined) {
      continue
    }
    if (ch === MARKER_OPEN || ch === MARKER_CLOSE) {
      flush()
      // validateMarkers 合格済みのため、直後のID文字は必ず存在し整合している
      if (ch === MARKER_OPEN) {
        const id = chars[i + 1]
        const def = id === undefined ? undefined : DEFINITION_BY_ID.get(id)
        if (def !== undefined) {
          stack.push(def)
        }
      } else {
        stack.pop()
      }
      i++
    } else {
      buffer += ch
    }
  }
  flush()
  return runs
}
